import { render, staticRenderFns } from "./homeOld.vue?vue&type=template&id=591df8e0&"
import script from "./homeOld.vue?vue&type=script&lang=js&"
export * from "./homeOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports